import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
// @ts-nocheck
var baseURL = "https://websdk.sawolabs.com";

var Sawo = /*#__PURE__*/function () {
  function Sawo(e) {
    var _this = this;

    _classCallCheck(this, Sawo);

    this.config = e, this.config.hostName = window.location.hostname, this.iframeID = Math.random().toString(36).substring(2, 15) + "sawo-iframe", this.eventPrefix = Math.random().toString(36).substring(2, 15), // attaching event 
    window.addEventListener("message", function (e) {
      if (e.origin === baseURL) switch (e.data.event) {
        case _this.eventPrefix + "LOGIN_SUCCESS":
          _this.config.onSuccess && _this.config.onSuccess(e.data.payload), _this.removeForm();
          break;

        case _this.eventPrefix + "LOAD_SUCCESS":
          document.getElementById(_this.iframeID).contentWindow.postMessage({
            event: _this.eventPrefix + "LOAD_CONFIG",
            payload: {
              identifierType: _this.config.identifierType,
              apiKey: _this.config.apiKey,
              hostName: _this.config.hostName
            }
          }, "*");
          break;

        default:
          console.log(e.data);
      }
    });
  }

  _createClass(Sawo, [{
    key: "showForm",
    value: function showForm() {
      var e = document.getElementById(this.config.containerID),
          t = document.createElement("iframe");
      t.id = this.iframeID, t.style.border = 0, e.appendChild(t), t.style.width = "100%", t.style.height = "100%", t.style.overflow = "scroll";
      var i = "".concat(baseURL, "/?eventPrefix=").concat(this.eventPrefix);
      t.setAttribute("src", encodeURI(i));
    }
  }, {
    key: "removeForm",
    value: function removeForm() {
      document.getElementById(this.iframeID).remove();
    }
  }]);

  return Sawo;
}();

export default Sawo;